import find from 'lodash-es/find';

import handleShoppablePause from './handleShoppablePause';
import formatImages from './formatImages';
import positionModal from './positionModal';
import prepareModal from './prepareModal';
import closeModal from './closeShoppableImage';
import updateSelectedVariant from './updateSelectedVariant';
import updatePriceForVariant from './updatePriceForVariant';
import get980Inventory from '../../sections/INF-ProductOverview/get980Inventory';

export default () => {
  handleShoppablePause();
  formatImages();

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-shoppable-image]')) {
      e.preventDefault();
      const trigger = e.target.closest('[data-shoppable-image]');
      const img = trigger.querySelector('img');

      if (!window.shoppablePaused) {
        prepareModal(trigger, img);
      }
    }
  });

  document.addEventListener('keyup', (e) => {
    if (e.target.closest('[data-shoppable-image]')) {
      e.preventDefault();
      const trigger = e.target.closest('[data-shoppable-image]');
      const img = trigger.querySelector('img');

      if (!window.shoppablePaused) {
        prepareModal(trigger, img);
      }
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-shoppable-modal-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keyup', (e) => {
    if (e.target.closest('[data-shoppable-modal-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.State--shoppable-image-open [data-site-overlay]')) {
      closeModal();
    }
  });

  window.addEventListener('resize', () => {
    positionModal();
  });

  document.addEventListener('change', (e) => {
    if (e.target.closest('[data-color-selector]') || e.target.closest('[data-size-selector]')) {
      const parent = e.target.closest('[data-shoppable-product]');

      // Log selectors object right after it's created
      const selectors = {
        addToCart: parent.querySelector('[data-add-to-cart]'),
        addToCartText: parent.querySelector('[data-add-to-cart-text]'),
        form: parent.querySelector('form[action="/cart/add"]'),
        image: parent.querySelector('[data-product-tile-image] img'),
        json: parent.querySelector('[data-product-json]'),
        id: parent.querySelector('[name="id"]'),
        color: parent.querySelector('[data-color-selector]'),
        size: parent.querySelector('[data-size-selector]'),
        priceContainer: parent.querySelector('[data-product-tile-price]'),
        price: parent.querySelector('[data-product-tile-price-main]'),
        compareAt: parent.querySelector('[data-product-tile-price-compare-at]'),
      };

      let inventory980 = window.inventory980 || false;

      updatePriceForVariant(parent, selectors, JSON.parse(selectors.json.innerHTML));
      updateSelectedVariant(parent, selectors, JSON.parse(selectors.json.innerHTML), inventory980);
    }
  });

  document.addEventListener('shoppableImageDidOpen', () => {
    // const products = document.querySelector('[data-shoppable-modal-products]');
    const productItems = document.querySelectorAll('[data-shoppable-product]');
    productItems.forEach((product) => {
      // Get the closest parent with the data-shoppable-product attribute
      const parent = product;

      const selectors = {
        addToCart: product.querySelector('[data-add-to-cart]'),
        addToCartText: product.querySelector('[data-add-to-cart-text]'),
        form: product.querySelector('form[action="/cart/add"]'),
        image: product.querySelector('[data-product-tile-image] img'),
        json: product.querySelector('[data-product-json]'),
        id: product.querySelector('[name="id"]'),
        color: product.querySelector('[data-color-selector]'),
        size: product.querySelector('[data-size-selector]'),
        priceContainer: product.querySelector('[data-product-tile-price]'),
        price: product.querySelector('[data-product-tile-price-main]'),
        compareAt: product.querySelector('[data-product-tile-price-compare-at]'),
      };

      const product_json = JSON.parse(selectors.json.innerHTML);
      const country = window.theme.country_iso;
      const compare_type = 'sku';

      const updateInventory = async () => {
        try {
          const res = await get980Inventory(false, compare_type, product_json);
          updateSelectedVariant(parent, selectors, product_json, res);
        } catch (error) {
          updateSelectedVariant(parent, selectors, product_json, false);
        }
      };

      if (country === 'US') {
        updateSelectedVariant(parent, selectors, product_json, false);
      } else if (window.inventory980) {
        updateSelectedVariant(parent, selectors, product_json, window.inventory980);
      } else {
        updateInventory();
      }
      window.selectedVariantId = selectors.id.value;
      const formOutput = document.querySelector('form[action="/cart/add"]');
      const idValue = formOutput.querySelector('input[name="id"]');
      idValue.value = window.selectedVariantId;
      // On first load update size selector
      const pre_selected_variant = find(product_json.variants, {
        id: parent.dataset.shoppableProductVariant,
      });
      if (pre_selected_variant) {
        selectors.id.value = pre_selected_variant.id;
        selectors.size.value = pre_selected_variant.option2;
        const colorSelect = selectors.color.querySelector('select');
        const sizeSelect = selectors.size.querySelector('select');
        const updateSelect = (selectElement) => {
          const event = new Event('change');
          selectElement.dispatchEvent(event);
        };

        // Call the updateSelect function when you want to "refresh" the selects
        updateSelect(colorSelect);
        updateSelect(sizeSelect);
      }
      updatePriceForVariant(parent, selectors, product_json);
    });
  });
};
